<template>
  <el-table class="text-xs" :data="messages" max-height="200px" size="mini" border>
    <el-table-column prop="sent_at" label="日時" width="160">
      <template #default="scope">
        <date-display :date="scope.row.sent_at" type="datetime" />
      </template>
    </el-table-column>
    <el-table-column prop="body" label="内容">
      <template #default="scope">
        <message-history-body
          v-if="Object.keys(scope.row).length > 0"
          :requestHeaderId="scope.row.request_header"
          :messageId="scope.row.message_id"
          :messageType="scope.row.message_type"
          :body="scope.row.body"
        />
      </template>
    </el-table-column>
    <el-table-column label="送信" show-overflow-tooltip>
      <template #default="scope">
        <message-sender-or-recipient-name
          :isApplicant="scope.row.is_applicant"
          :departmentName="scope.row.department_name"
          :sectionName="scope.row.section_name"
          :userName="scope.row.user_name"
        />
      </template>
    </el-table-column>
    <el-table-column label="受信">
      <template #default="scope">
        <el-tooltip
          :content="
            scope.row.message_address
              .map((address) =>
                displaySenderOrRecipientName({
                  isApplicant: address.is_applicant,
                  departmentName: address.department_name,
                  userName: address.user_name,
                })
              )
              .join('\n')
          "
          effect="dark"
          placement="top"
          popper-class="pre-wrap-tooltip"
        >
          <div
            class="recipient-row"
            v-html="
              `<span>${scope.row.message_address
                .map((address) =>
                  displaySenderOrRecipientName({
                    isApplicant: address.is_applicant,
                    departmentName: address.department_name,
                    userName: address.user_name,
                  })
                )
                .join('</span><span>')}</span>`
            "
          />
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive } from 'vue'
import { ListRequest } from '@/requests/message'
import { Message } from '@/api'
import { AxiosResponse } from 'axios'
import DateDisplay from '@/components/displays/DateDisplay.vue'
import MessageSenderOrRecipientName from '@/components/displays/MessageSenderOrRecipientName.vue'
import MessageHistoryBody from '@/components/displays/MessageHistoryBody.vue'

import { displaySenderOrRecipientName } from '@/services/messageAddress'

/**
 * メッセージ履歴の表示コンポーネント
 * 特定のメッセージ種別のみ表示
 */
export default defineComponent({
  name: 'MessageHistoryToMessageType',
  components: {
    DateDisplay,
    MessageSenderOrRecipientName,
    MessageHistoryBody,
  },
  props: {
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: true,
    },
    //履歴表示対象メッセージ種別
    targetMessageTypes: {
      type: Array as PropType<number[]>,
      required: true,
    },
  },
  async setup(props) {
    const messages = reactive<Message[]>([])
    const request = new ListRequest(props.requestHeaderId)
    await request.exec()
    if (request.success) {
      const { data } = request.getResponse() as AxiosResponse<Message[]>

      //履歴表示対象のメッセージ種別のメッセージを取得
      const targetMessages = data.filter((message) => {
        return props.targetMessageTypes.includes(message.message_type)
      })
      messages.push(...targetMessages)
    }

    return {
      displaySenderOrRecipientName,
      messages,
    }
  },
})
</script>

<style lang="scss" scoped>
.text-omit {
  width: 100%;
  display: inline-block;
}
.recipient-row {
  line-height: initial;
}
::v-deep(.recipient-row > span) {
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
